import { EVENTS } from "@archetype-themes/utils/events";
let abortController = new AbortController();
let isMobileNavOpen = false;
  // Trigger to open header nav
  let openTrigger = document.querySelector('[aria-controls="MobileNav"]');
  // if (!openTrigger) return;
  // Open/close mobile nav
  if(openTrigger){
    openTrigger.addEventListener("click", handleClick.bind(this), {
      signal: abortController.signal,
    });
  
    // Drawer actions
    document.addEventListener(
      EVENTS.headerDrawerClosed,
      handleDrawerClosed.bind(this),
      {
        signal: abortController.signal,
      }
    );
  }
  
  function handleClick(evt) {
    evt.preventDefault();
    if (isMobileNavOpen) {
      evt.target.dispatchEvent(
        new CustomEvent(EVENTS.mobileNavClose, { bubbles: true })
      );
      openTrigger.classList.remove("is-active");
      // this.classList.remove('mobile-nav-open')
      isMobileNavOpen = false;
    } else {
      evt.target.dispatchEvent(
        new CustomEvent(EVENTS.mobileNavOpen, { bubbles: true })
      );
      openTrigger.classList.add("is-active");
      // this.classList.add('mobile-nav-open')
      isMobileNavOpen = true;
    }
  }

  function handleDrawerClosed() {
    isMobileNavOpen = false;
    openTrigger.classList.remove("is-active");
  }
// document.addEventListener("DOMContentLoaded", () => {
  
// });
window.addEventListener('beforeunload', () => {
  if (abortController) {
    abortController.abort();
  }
});
// ===============================================================================================
  //   class ToggleMenu extends HTMLElement {
  //     connectedCallback() {
  //       console.log(222222222)
  //       this.abortController = new AbortController()
  //       this.isMobileNavOpen = false
  //       // Trigger to open header nav
  //       this.openTrigger = this.querySelector('[aria-controls="MobileNav"]')

  //       if (!this.openTrigger) return
  //       // Open/close mobile nav
  //       this.openTrigger.addEventListener('click', this.handleClick.bind(this), { signal: this.abortController.signal })

  //       // Drawer actions
  //       document.addEventListener(EVENTS.headerDrawerClosed, this.handleDrawerClosed.bind(this), {
  //         signal: this.abortController.signal
  //       })
  //     }
  //     handleClick(evt) {
  //       evt.preventDefault()
  //       if (this.isMobileNavOpen) {
  //         evt.target.dispatchEvent(new CustomEvent(EVENTS.mobileNavClose, { bubbles: true }))
  //         this.openTrigger.classList.remove('is-active')
  //         // this.classList.remove('mobile-nav-open')
  //         this.isMobileNavOpen = false
  //       } else {
  //         evt.target.dispatchEvent(new CustomEvent(EVENTS.mobileNavOpen, { bubbles: true }))
  //         this.openTrigger.classList.add('is-active')
  //         // this.classList.add('mobile-nav-open')
  //         this.isMobileNavOpen = true
  //       }
  //     }

  //     handleDrawerClosed() {
  //       this.isMobileNavOpen = false
  //       this.openTrigger.classList.remove('is-active')
  //     }

  //     disconnectedCallback() {
  //       this.abortController.abort()
  //     }
  // }
  //   customElements.define('toggle-menu', ToggleMenu);
